import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, RoutingConfig, UrlModule } from '@spartacus/core';
import { CmsPageGuard, MediaModule, PageLayoutComponent } from '@spartacus/storefront';
import { KnBrDirectiveModule } from 'src/shared/directive/kn-br-directive.module';
import { KnBrCustomerContextGuard } from 'src/shared/guards/kn-br-customer-context.guard';
import { KnBrAddToCartModule } from '../../base/components/kn-br-add-to-cart/kn-br-add-to-cart.module';
import { KnBrAddToQuoteModule } from '../../base/components/kn-br-add-to-quote/kn-br-add-to-quote.module';
import { KnBrFlashTooltipDirective } from './kn-br-flash-tooltip.directive';
import { KnBrQuickOrderComponent } from './kn-br-quick-order.component';

@NgModule({
  declarations: [KnBrQuickOrderComponent, KnBrFlashTooltipDirective],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    I18nModule,
    MediaModule,
    UrlModule,
    NgbModule,
    KnBrAddToCartModule,
    KnBrAddToQuoteModule,
    KnBrDirectiveModule,
    ConfigModule.withConfig({
      cmsComponents: {
        KnBrQuickOrderComponent: {
          component: () => import('./kn-br-quick-order.component').then((c) => c.KnBrQuickOrderComponent),
        },
      },
    } as CmsConfig),
    RouterModule.forChild([
      {
        data: { pageLabel: '/quick-order', cxRoute: 'quickOrder' },
        path: null,
        canActivate: [AuthGuard, CmsPageGuard, KnBrCustomerContextGuard],
        component: PageLayoutComponent,
      },
    ]),
    ConfigModule.withConfig({
      routing: {
        routes: {
          quickOrder: {
            paths: ['quick-order'],
          },
        },
      },
    } as RoutingConfig),
  ],
})
export class KnBrQuickOrderModule { }
